<template>
  <div>
    <div class="page-header">
		<div class="add-item d-flex">
			<div class="page-title">
				<h4>{{ $t('chart_of_accounts') }}</h4>
			</div>
		</div>
<!--		<ul class="table-top-head">-->
<!--			<li>-->
<!--				<a data-bs-toggle="tooltip" data-bs-placement="top" title="Pdf"><img src="/assets/img/icons/pdf.svg" alt="img"></a>-->
<!--			</li>-->
<!--			<li>-->
<!--				<a data-bs-toggle="tooltip" data-bs-placement="top" title="Excel"><img src="/assets/img/icons/excel.svg" alt="img"></a>-->
<!--			</li>-->
<!--			<li>-->
<!--        <a data-bs-toggle="tooltip" data-bs-placement="top" title="Print"><i class="ti ti-printer"></i></a>-->
<!--      </li>-->
<!--      <li>-->
<!--        <a data-bs-toggle="tooltip" data-bs-placement="top" title="Refresh"><i class="ti ti-refresh"></i></a>-->
<!--      </li>-->
<!--      <li>-->
<!--        <a data-bs-toggle="tooltip" data-bs-placement="top" title="Collapse" id="collapse-header"><i class="ti ti-chevron-up"></i></a>-->
<!--      </li>-->
<!--		</ul>-->
		<div class="page-btn">
			<!-- Trigger Button for Modal -->
			<!-- <a href="#" class="btn btn-added" data-bs-toggle="modal" data-bs-target="#create-modal">
				<i class="ti ti-circle-plus me-2 text-white"></i>{{ $t('add_new_accounts') }}
			</a> -->
			<!-- Modal Component -->
			
		</div>
	</div>
	<!-- /product list -->
	<div class="card table-list-card">
		<div class="card-body">
			<div class="table-responsive">
				<DataTable v-if="sub_categories.length" :tableId="'subCategoryTable'">
					<thead>
						<tr>
							<th>{{ $t('account_no') }}</th>
							<th>{{ $t('account_name') }}</th>
							<th class="no-sort">{{ $t('action') }}</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="sub_category in sub_categories" :key="sub_category.id">
							<td>{{ sub_category.account_id }}</td>
							<td>
								<a v-if="sub_category.p_id != 0" class="me-2 p-2" href="#" @click="fetchParentAccounts(sub_category.p_id)"><i class="fas fa-arrow-left"></i></a>
								<span>
								
								{{ sub_category.node }}

								<a v-if="sub_category.status != 'Child'" class="me-2 p-2" href="#" @click="fetchSubCategories(sub_category.account_id)"><i class="fas fa-arrow-right"></i></a>
								</span>
								<!-- <span v-else>{{ sub_category.node }}</span> -->
							</td>
							<td class="action-table-data d-flex">
								<a v-if="sub_category.status != 'Child'" href="#" class="btn me-2" title="Add Child Account" @click="addAccountsModal(sub_category)">
									<i class="ti ti-circle-plus me-2"></i>
								</a>
							<div class="edit-delete-action">
								<a class="me-2 p-2" href="#" @click.prevent="openEditModal(sub_category)">
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ti ti-edit">
										<path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
									</svg>
								</a>
								<!-- <a class="confirm-text p-2" href="javascript:void(0);">
									<i data-feather="trash-2" class="feather-trash-2"></i>
								</a> -->
							</div>
							</td>
						</tr>							
					</tbody>
				</DataTable>
        <!-- If No Data -->
        <div v-else class="d-flex flex-column align-items-center justify-content-center p-5 bg-light rounded shadow-sm">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="#6c757d" class="mb-3" viewBox="0 0 16 16">
            <path d="M8 0a8 8 0 1 0 8 8A8.009 8.009 0 0 0 8 0zm0 15A7 7 0 1 1 15 8a7.008 7.008 0 0 1-7 7z"/>
            <path d="M5.354 4.646a.5.5 0 0 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z"/>
          </svg>
          <h5 class="text-muted">No Data Found</h5>
          <p class="text-secondary small">Try adjusting filters or add new data.</p>
        </div>

				<EditModal :categories="parent_accounts" :selectedSubCategory="selectedSubCategory" @edit_success="fetchSubCategories" />
				<CreateModal
				:categories="parent_accounts"
				@create_success="fetchSubCategories"
			/>
			</div>
		</div>
	</div>
<!-- /product list -->
    
  </div>
</template>

<script>
import CreateModal from '@/views/admin_dashboard/chart_of_accounts/CreateModal.vue';
import EditModal from '@/views/admin_dashboard/chart_of_accounts/EditModal.vue';
import DataTable from '@/components/common/DataTable.vue';
import apiUrls from '../../../urls';
export default {
  inject: ['globalLoading'],
  components: {
    CreateModal,
    EditModal,
    DataTable,
  },
  data() {
    return {
      sub_categories: [], 
      selectedSubCategory: {},
      categories: [],
      parent_accounts:[],
    };
  },
  methods: {
    async fetchCategories() {
      try {
        const response = await this.$axios.get(apiUrls.chart_of_accounts.get);
        this.categories = response.data;
      } catch (error) {
        console.error("Error fetching categories:", error);
        this.errorMessage = "Unable to load categories.";
      }
    },
    addAccountsModal(category){
    	this.parent_accounts = [category];
      this.$nextTick(() => {
        const modal = new bootstrap.Modal(document.getElementById('create-modal'));
        modal.show();
      });
    },
    openEditModal(sub_category) {
        this.selectedSubCategory = sub_category;
        this.$nextTick(() => {
        const modal = new bootstrap.Modal(document.getElementById('edit-modal'));
        modal.show();
      });
    },
    async fetchSubCategories(parent_id=0) {
	    this.globalLoading(true)
	    console.log(parent_id)
      try {
      	const response = await this.$axios.get(apiUrls.chart_of_accounts.get, {
          params: { p_id: parent_id, head_status:'Enable' }
        })
        
        // const response = await this.$axios.get(apiUrls.chart_of_accounts.get);
        if(response.data.length > 0){
        	this.sub_categories = response.data; 
        }
        
      } catch (error) {
        console.error("Error fetching sub categories:", error);
      } finally {
        this.globalLoading(false)
      }
    },
    async fetchParentAccounts(account_id) {
	    this.globalLoading(true)
      try {
      	const response1 = await this.$axios.get(apiUrls.chart_of_accounts.get, {
          params: { account_id: account_id, head_status:'Enable' }
        })
        let parent_id = response1.data[0].p_id
        const response = await this.$axios.get(apiUrls.chart_of_accounts.get, {
          params: { p_id: parent_id, head_status:'Enable' }
        })
        this.sub_categories = response.data; 
      } catch (error) {
        console.error("Error fetching sub categories:", error);
      } finally {
        this.globalLoading(false)
      }
    },
  },
  created() {
	  this.fetchCategories();
    this.fetchSubCategories(); 
  },
};
</script>
